module.exports = __webpack_public_path__ + "img/car4.20563c49.png";